import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { APP_NAME, COMPANY } from '@lx/shared/tokens';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { BASE_PATH } from '@lx/shared/api/variables';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { LoggerModule, NgxLoggerLevel, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { CONFIGURATION_PROVIDER, CustomisedNGXLoggerServerService } from '@lx/shared/app-init';
import { APPLICATION_CONFIGURATION_SERVICE } from '@lx/shared/app-config';
import { getErrorHandlerProviders } from '@lx/shared/storybook-utils';
import { ApplicationConfigurationService } from './application-configuration.service';
import { MessageService } from 'primeng/api';
import { httpErrorInterceptorFn } from '@lx/shared/errors';
import { PriceListCourseBandsService } from './services/pricelist-course-bands.service';
import { PriceListAccommodationBandsService } from './services/pricelist-accommodation-bands.service';
import { PriceListTransferFeeBandsService } from './services/pricelist-transfer-fee-bands.service';
import { getAppInitializers, PRIVATE_PRICE_LIST_API_PROVIDER } from './functions';
import { PRIVATE_BASE_PATH } from './tokens/private-base-path.token';
import { JuniorCampsPackagesBandsService } from './services/junior-camps-packages-bands.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors([httpErrorInterceptorFn])),
    provideRouter(routes),
    importProvidersFrom(
      LoggerModule.forRoot(
        {
          level: NgxLoggerLevel.DEBUG,
          disableConsoleLogging: false,
          serverLogLevel: NgxLoggerLevel.ERROR,
        },
        {
          serverProvider: {
            provide: TOKEN_LOGGER_SERVER_SERVICE,
            useClass: CustomisedNGXLoggerServerService,
          },
        },
      ),
    ),
    { provide: APPLICATION_CONFIGURATION_SERVICE, useClass: ApplicationConfigurationService },
    ...getAppInitializers(),
    {
      provide: PriceListCourseBandsService,
      useClass: PriceListCourseBandsService,
    },
    {
      provide: PriceListTransferFeeBandsService,
      useClass: PriceListTransferFeeBandsService,
    },
    {
      provide: PriceListAccommodationBandsService,
      useClass: PriceListAccommodationBandsService,
    },
    {
      provide: JuniorCampsPackagesBandsService,
      useClass: JuniorCampsPackagesBandsService,
    },
    MessageService,
    ...getErrorHandlerProviders(),
    { provide: BASE_PATH, useValue: environment.API_BASE_PATH },
    { provide: PRIVATE_BASE_PATH, useValue: environment.API_PRIVATE_BASE_PATH },
    { provide: COMPANY, useValue: environment.COMPANY },
    { provide: LOCALE_ID, useValue: environment.LOCALE },
    { provide: APP_NAME, useValue: 'price-lists-portal' },
    PRIVATE_PRICE_LIST_API_PROVIDER,
    CONFIGURATION_PROVIDER,
  ],
};
